import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from "../../../services/AppComponentBase";



@Component({
    selector: "modal-disconnectionInfoModal",
    template: require('./disconnectionInfoModal.component.html'),
    styles: [require('./disconnectionInfoModal.component.css')]
})

export class disconnectionInfoModal extends AppComponentBase
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);
    }

    public logoutAction()
    {
        this.forceLogout();
    }

   
}


